import { Media } from "./video";

export default class VideoQueue {
    private _queue: Media[] = [];

    get isEmpty() {
        return this._queue.length === 0;
    }

    get copy() {
        return this._queue.slice();
    }

    toString = () => {
        return this._queue.map((video, idx) => `${idx}: ${video.name}`);
    };

    head = () => {
        if (this.isEmpty) throw new Error("Access head on empty Video queue");
        return this._queue[0];
    };

    enqueue = (video: Media) => {
        this._queue.push(video);
    };

    clear = () => {
        this._queue = [];
    };

    getNextVideo = (): Media => {
        const next = this._queue.shift();

        if (!next) {
            console.error("Somehow empty");
            return this.head();
        }

        if (this.isEmpty) {
            this._queue.push(next);
        }

        return this.head();
    };
}
